import { useTitle } from '@vueuse/core';
import type { Router } from 'vue-router';
import { $t } from '@/locales';

/**
 * 全局后置路由守卫，主要用于修改页面标题
 *
 * @param router
 */
export function createDocumentTitleGuard(router: Router) {
  router.afterEach(to => {
    const { i18nKey, title } = to.meta;

    const documentTitle = i18nKey ? $t(i18nKey) : title;
    // 修改页面标题（浏览器标签页上的标题）
    useTitle(documentTitle);
  });
}
